import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "odometer tnum",
    "aria-label": _ctx.text,
    role: "img"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chars, (c) => {
      return (_openBlock(), _createElementBlock("span", {
        key: c.key,
        class: _normalizeClass(['odo-cell', { 'is-fraction': c.fraction, 'is-sep': c.digit === null }]),
        "aria-hidden": "true"
      }, [
        (c.digit !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "odo-strip",
              style: _normalizeStyle({ transform: `translateY(${-(_ctx.mounted ? c.digit : 0) * 10}%)`, transitionDelay: `${(c.key % 6) * 40}ms` })
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                return _createElementVNode("span", { key: n }, _toDisplayString(n - 1), 1)
              }), 64))
            ], 4))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(c.ch), 1)
            ], 64))
      ], 2))
    }), 128))
  ], 8, _hoisted_1))
}